import Question from './Question';
import { shouldSkipQuestion } from '../logic/assessment';

type QuestionListType = {
    focus: boolean;
    question: any;
    answers: any;
    onChangeCallback: any
    reviewMode: boolean
    fakeFunc: any
};
export const QuestionListItem = ({focus, question, answers, onChangeCallback, reviewMode, fakeFunc}: QuestionListType) => {
    if(!reviewMode && shouldSkipQuestion(question, answers)) {
        return <></>
    }

    return <Question
        focus={focus}
        data={question}
        variables={answers}
        onChangeCallback={onChangeCallback}
        isOverview={true}
    />
}
